class StickyHeader extends HTMLElement {

  constructor() {
    super();
    this.element = this;
    this.announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.header = this.querySelector('[data-header]');

    this.lastScrollTop = 0;

    this.scrollBreakpoint = this.announcementBar.offsetHeight + this.header.offsetHeight;
    
    // Check and set correct state when first loaded
    this.onScroll();

    // See if the header is scrolled
    window.addEventListener('scroll', (event) => {
      this.onScroll(event);
    });

    window.addEventListener('resize', (event) => {
      this.onResize(event);
    });

  }

  /**
   * onScroll
   * @description Handles the scroll interaction
   */
  onScroll() {
    this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if(this.currentScrollTop > this.lastScrollTop && this.currentScrollTop > this.scrollBreakpoint) {
      this.setScrolledState();
    } else if(this.currentScrollTop <= this.lastScrollTop && this.currentScrollTop <= this.scrollBreakpoint) {
      this.removeScrolledState();
    }

    // Set current scroll value to last
    this.lastScrollTop = this.currentScrollTop;
  }

  /**
   * setScrolledState
   * @description Set the toggled scrolled state
   */
  setScrolledState() {
    document.body.classList.add('header-is-scrolled');
  }

  /**
   * removeScrolledState
   * @description Remove the toggled scrolled state
   */
  removeScrolledState() {
    document.body.classList.remove('header-is-scrolled');
  }

  /**
   * onResize
   * @description Recalculates the breakpoint based on the height of elements
   */
  onResize() {
    this.scrollBreakpoint = this.announcementBar.offsetHeight + this.header.offsetHeight;
  }

}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}